import Vue from "vue"
import Vuex from "vuex"
import { protectedAxiosInstance } from "@/utils/axiosConfig"
import register from "./auth/register"
import login from "./auth/login"
import sockets from "./sockets"
import router from "../router/index"

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		AUTHENTICATED: false,
		MY_PROFILE: {
			email: "",
			activated: false,
			name: "",
			nickname: "",
			friends: [],
			groups: []
		}
	},
	mutations: {
		SET_AUTHENTICATED(state, status) {
			state.AUTHENTICATED = status
		},
		SET_MY_PROFILE(state, profile) {
			state.MY_PROFILE = profile
		},
		SET_FRIEND_STATUS(state, { isOnline, nickname }) {
			const index = state.MY_PROFILE.friends.findIndex(
				(friend) => friend.nickname === nickname
			)
			if (index !== -1) {
				Vue.set(state.MY_PROFILE.friends[index], "online", isOnline)
			}
		},
		ADD_FRIEND(state, friend) {
			Vue.set(
				state.MY_PROFILE.friends,
				state.MY_PROFILE.friends.length,
				friend
			)
		}
	},
	getters: {
		MY_FRIENDS(state) {
			return state.MY_PROFILE.friends
		}
	},
	actions: {
		async GET_MY_PROFILE({ commit }) {
			const {
				data: { data, success }
			} = await protectedAxiosInstance.get("/user-profiles/my-profile")

			if (success) {
				commit("SET_MY_PROFILE", data)
				commit("sockets/ADD_CHATS", data.friends)
				if (router.history.current.name !== "index") {
					router.push({ name: "index" })
				}
			} else {
				router.push({ name: "login" })
			}
			commit("SET_AUTHENTICATED", success)
		},
		async ADD_FRIEND({ commit }, nickname) {
			const {
				data: { data: friend }
			} = await protectedAxiosInstance.post("/friends/add", {
				nickname
			})
			commit("ADD_FRIEND", friend)
		}
	},
	modules: {
		register,
		login,
		sockets
	}
})
